import { platformReviews } from '@/mocks/home';

export default function PlatformReviews() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
            平台评测
          </span>
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950 mb-3">
            合规平台深度评测
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            严格甄选 · 客观评测 · 安全合规 · 专属福利
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {platformReviews.map((platform, index) => (
            <div
              key={platform.id}
              className="relative bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-300/50"
            >
              {index === 0 && (
                <div className="absolute top-0 right-0 bg-primary-500 text-background-50 text-xs font-bold px-3 py-1 rounded-bl-lg whitespace-nowrap">
                  编辑推荐
                </div>
              )}

              <div className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex items-center gap-3">
                    <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 text-lg">
                      <i className={platform.logo}></i>
                    </span>
                    <div>
                      <h3 className="font-heading font-bold text-lg text-foreground-900">
                        {platform.name}
                      </h3>
                      <div className="flex items-center gap-1 mt-0.5">
                        {Array.from({ length: 5 }).map((_, i) => {
                          const filled = i < Math.floor(platform.rating / 2);
                          const half = !filled && i < Math.round(platform.rating / 2);
                          return (
                            <span key={i} className="w-3.5 h-3.5 flex items-center justify-center">
                              <i
                                className={`text-xs ${
                                  filled
                                    ? 'ri-star-fill text-primary-500'
                                    : half
                                      ? 'ri-star-half-line text-primary-500'
                                      : 'ri-star-line text-background-300'
                                }`}
                              ></i>
                            </span>
                          );
                        })}
                        <span className="text-xs font-semibold text-foreground-700 ml-1">
                          {platform.rating}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {platform.review}
                </p>

                <div className="flex flex-wrap gap-2 mb-4">
                  {platform.highlights.map((h) => (
                    <span
                      key={h}
                      className="px-2.5 py-1 bg-accent-100 text-accent-700 rounded-md text-xs font-medium"
                    >
                      {h}
                    </span>
                  ))}
                </div>

                <div className="p-3 bg-primary-50 rounded-lg border border-primary-200/50 mb-4">
                  <div className="flex items-center gap-2">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-gift-line text-primary-500 text-sm"></i>
                    </span>
                    <span className="text-xs font-semibold text-primary-700">
                      {platform.bonus}
                    </span>
                  </div>
                </div>

                <a
                  href={platform.url}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="block w-full text-center px-6 py-3 bg-primary-500 text-background-50 rounded-lg text-sm font-semibold transition-all duration-200 hover:bg-primary-600 whitespace-nowrap cursor-pointer"
                >
                  立即注册领取福利
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}